import { render, staticRenderFns } from "./PlayBtn.vue?vue&type=template&id=294aa149&scoped=true"
import script from "./PlayBtn.vue?vue&type=script&lang=ts"
export * from "./PlayBtn.vue?vue&type=script&lang=ts"
import style0 from "./PlayBtn.vue?vue&type=style&index=0&id=294aa149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294aa149",
  null
  
)

export default component.exports